// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer__info":"Footer_footer__info__i7n8Y","confidentiality":"Footer_confidentiality__btnvG"};